// extracted by mini-css-extract-plugin
export default {"upgradeForm":"SelectProduct_upgradeForm__cjQkv","summary":"SelectProduct_summary__43O1K","label":"SelectProduct_label__7F4PT","couponLabel":"SelectProduct_couponLabel__LM6Di"};